import { AppNames } from '@pinnakl/shared/types';

export interface AppApiAccess {
  scopes: string[];
  audience: string;
}

export const appApiAccess: Partial<Record<AppNames, AppApiAccess>> = {
  [AppNames.CRM]: { scopes: ['api.crm:read', 'api.crm:write'], audience: 'crm' },
  [AppNames.PLATFORM_WEB]: { scopes: ['api.poems:read', 'api.poems:write'], audience: 'poems' },
};
